import React, {
  useState,
  useCallback,
  createContext,
  useContext,
  useEffect,
} from 'react';
import Loading from '#coreComponents/Loading';

export const LoadingContext = createContext<{
  isLoading: boolean;
  finishedLoading: () => void;
  setIsLoading: (isLoading: boolean) => void;
}>({
  isLoading: true,
  finishedLoading: () => {},
  setIsLoading: () => {},
});

export const useAppLoading = () => useContext(LoadingContext);

const AppLoading: React.FC<{}> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(true);
  const finishedLoading = useCallback(() => {
    setTimeout(() => setIsVisible(false), 0);
  }, [setIsVisible]);
  return (
    <LoadingContext.Provider
      value={{
        finishedLoading,
        isLoading: isVisible,
        setIsLoading: (isLoading) => setIsVisible(isLoading),
      }}
    >
      {isVisible && (
        <Loading
          width="100vw"
          height="100vh"
          zIndex="popover"
          showLogo={true}
          data-testid="loading-component"
        />
      )}
      {children}
    </LoadingContext.Provider>
  );
};

export const FinishedLoading: React.FC<{}> = ({ children }) => {
  const { isLoading, finishedLoading } = useAppLoading();
  useEffect(() => {
    if (isLoading) {
      finishedLoading();
    }
  }, [isLoading, finishedLoading]);
  return <>{children}</>;
};

export default AppLoading;
